import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { cacheRolesMeta, reportClientLog } from './lib/api';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Preload dynamic role labels from backend meta
cacheRolesMeta();

// 전역 런타임 오류 수집(중앙로그가 없을 때 서버 로그로 모음)
let _clientLogHandlersInstalled = false
function installClientLogHandlers() {
  if (_clientLogHandlersInstalled) return
  _clientLogHandlersInstalled = true

  try {
    window.addEventListener('error', (e) => {
      try {
        const route = window.location?.pathname || ''
        const url = window.location?.href || ''
        const ua = navigator?.userAgent || ''
        const msg = e?.message || (e?.error?.message) || 'window.error'
        const stack = e?.error?.stack || ''
        reportClientLog({ level: 'error', source: 'window.error', route, url, message: msg, stack, userAgent: ua })
      } catch (_) { }
    })

    window.addEventListener('unhandledrejection', (e) => {
      try {
        const route = window.location?.pathname || ''
        const url = window.location?.href || ''
        const ua = navigator?.userAgent || ''
        const reason = e?.reason
        const msg = (reason && reason.message) ? reason.message : String(reason || 'unhandledrejection')
        const stack = reason && reason.stack ? reason.stack : ''
        reportClientLog({ level: 'error', source: 'unhandledrejection', route, url, message: msg, stack, userAgent: ua })
      } catch (_) { }
    })
  } catch (_) { }
}
installClientLogHandlers()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
